import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		root: {
			borderRight: "1px solid rgba(0, 0, 0, .02)",
		},
	} satisfies Record<string, CSSObject>);
};
